// This file serves as a template. During prebuild, PLACEHOLDERS are replaced
// with actual values from environment variables by running node set-environment.js
export const environment = {
  production: 'false',
  recaptcha: {
    siteKey: '6Lf4jt8sAAAAAF-hjqIypPMiDM4Cui6tVKET7fTZ'
  },
  footerLinks: {
    // about: '',
    // notices: '',
    faqs: 'https://services-uat.judiciary.gov.sg/Portal/FAQ',
    contactUs: 'https://www.judiciary.gov.sg/contact-us',
    reportVulnerability: 'https://www.tech.gov.sg/report-vulnerability'
  }
};
